<template>
  <div>
    <el-form
      :model="queryParams"
      :rules="rules"
      ref="operation"
      style="margin-bottom: 0; background-color: #fff; padding: 20px"
      label-width="150px"
    >
      <!-- 注册企业数量 -->
      <el-form-item
        label="注册企业数量："
        prop="registeredEnterprises"
        class="required-field"
      >
        <el-input
          v-model="queryParams.registeredEnterprises"
          placeholder="请输入注册企业数量"
          clearable
        />
      </el-form-item>

      <!-- 服务商企业数量 -->
      <el-form-item
        label="服务商企业数量："
        prop="serviceProviderEnterprises"
        class="required-field"
      >
        <el-input
          v-model="queryParams.serviceProviderEnterprises"
          placeholder="请输入服务商企业数量"
          clearable
        />
      </el-form-item>

      <!-- 规上企业数量 -->
      <el-form-item label="规上企业数量：" prop="scaleEnterprises">
        <el-input
          v-model="queryParams.scaleEnterprises"
          placeholder="请输入规上企业数量"
          clearable
        />
      </el-form-item>

      <!-- 专精特新企业数量 -->
      <el-form-item label="专精特新企业数量：" prop="specializedEnterprises">
        <el-input
          v-model="queryParams.specializedEnterprises"
          placeholder="请输入专精特新企业数量"
          clearable
        />
      </el-form-item>

      <!-- 小巨人企业数量 -->
      <el-form-item label="小巨人企业数量：" prop="littleGiantEnterprises">
        <el-input
          v-model="queryParams.littleGiantEnterprises"
          placeholder="请输入小巨人企业数量"
          clearable
        />
      </el-form-item>

      <!-- 上市企业数量 -->
      <el-form-item label="上市企业数量：" prop="listedEnterprises">
        <el-input
          v-model="queryParams.listedEnterprises"
          placeholder="请输入上市企业数量"
          clearable
        />
      </el-form-item>
    </el-form>
    <div class="organization-info-view">
      <p class="info-title">园区运营机构信息1</p>

      <div class="borganization-info-block">
        <div class="table-box ly_table_light">
          <p>企业1</p>
          <el-table
            :data="companyList"
            border
            style="width: 650px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column
              prop="talentId"
              label="企业编号"
              align="center"
              width="260"
            ></el-table-column>

            <el-table-column
              prop="userName"
              label="企业名称"
              align="center"
              width="390"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="borganization-info-block">
        <div class="table-box ly_table_light">
          <p>服务商</p>
          <el-table
            :data="serveList"
            border
            style="width: 650px"
            header-cell-class-name="ly_table_light_header"
            cell-class-name="ly_table_light_cell"
          >
            <el-table-column
              prop="recruitmentId"
              label="企业编号"
              align="center"
              width="260"
            ></el-table-column>

            <el-table-column
              prop="recruitmentName"
              label="企业名称"
              align="center"
              width="390"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getOrganizationInfo } from "@/api/customCompany.js";
export default {
  data() {
    return {
      queryParams: {
        registeredEnterprises: "",
        serviceProviderEnterprises: "",
        scaleEnterprises: "",
        specializedEnterprises: "",
        littleGiantEnterprises: "",
        listedEnterprises: "",
      },
      serveList: [],
      companyList: [], // 核心团队信息
      isInit: false,
      rules: {
        registeredEnterprises: [
          { required: true, message: "请输入注册企业数量", trigger: "blur" },
        ],
        serviceProviderEnterprises: [
          { required: true, message: "请输入服务商企业数量", trigger: "blur" },
        ],
        scaleEnterprises: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        specializedEnterprises: [
          { required: true, message: "请输入", trigger: "blur" },
          ,
        ],
        littleGiantEnterprises: [
          { required: true, message: "请输入", trigger: "blur" },
          ,
        ],
        listedEnterprises: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getInfo() {
      this.companyList = [
        {
          talentId: "",
          userName: "",
        },
      ];
      this.serveList = [
        {
          recruitmentId: "",
          recruitmentName: "",
        },
      ];
      return;
      if (this.isInit) {
        return;
      }

      getOrganizationInfo({ id: this.$route.query.id }).then((res) => {
        if (res.code == 200) {
          this.isInit = true;

          if (res.data && Array.isArray(res.data.zcRecruitmentList)) {
            this.zcRecruitmentList = res.data.zcRecruitmentList;
          }

          if (res.data && Array.isArray(res.data.zcTeamList)) {
            this.zcTeamList = res.data.zcTeamList;
          }
        }
      });
    },
    submitForm() {
      this.$refs.operation.validate((valid) => {
        if (valid) {
          //   this.$message.success("提交成功！");
        } else {
          this.$message.error("请检查表单填写是否正确");
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.operation.resetFields();
    },
  },
};
</script>

<style scoped lang="less">
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  width: 470px;
}
.organization-info-view {
  .info-title {
    margin-top: 10px;
    margin-bottom: 11px;
    font-size: 18px;
    line-height: 25px;
  }
  .borganization-info-block {
    border-bottom: 20px solid #d8efff;
    margin-bottom: 20px;
  }
  .borganization-info-block:last-child{
    border: none;
  }

  .table-box {
    padding-left: 190px;
    padding-bottom: 10px;
    p {
      margin-bottom: 20px;
    }

    .table-title {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      font-size: 16px;
      color: #333333;

      &::before {
        content: "";
        display: block;
        margin-right: 4px;
        width: 7px;
        height: 7px;
        background-color: #1e9fff;
        border-radius: 50%;
      }
    }
  }
}
::v-deep .el-table--scrollable-x .el-table__body-wrapper {
  overflow: hidden;
}
</style>